import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { WizardContext } from './context';
const PERCENTAGE_FACTOR = 100;
export function WizardProvider({ steps, children, initialStep }) {
    const initialStepIndex = initialStep ? steps.findIndex((step) => step === initialStep) : 0;
    const [currentStepIndex, setCurrentStepIndex] = useState(initialStepIndex);
    const goToStep = useCallback((stepIndex) => {
        if (typeof steps[stepIndex] !== 'undefined') {
            setCurrentStepIndex(stepIndex);
        }
    }, [steps]);
    const goToNextStep = useCallback(() => {
        goToStep(currentStepIndex + 1);
    }, [goToStep, currentStepIndex]);
    const goToPreviousStep = useCallback(() => {
        goToStep(currentStepIndex - 1);
    }, [goToStep, currentStepIndex]);
    return (_jsx(WizardContext.Provider, { value: {
            goToStep,
            goToNextStep,
            goToPreviousStep,
            currentStep: steps[currentStepIndex],
            isFirstStep: currentStepIndex === 0,
            isLastStep: currentStepIndex + 1 === steps.length,
            stepProgress: (currentStepIndex / (steps.length - 1)) * PERCENTAGE_FACTOR
        }, children: children }));
}
